module.exports = __webpack_public_path__ + "img/neo-icon-white.b78fd521.svg";